const CONFIG_KEY = 'NEWRON_PLATFORM_CONFIG';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function getConfig() {
  const config: Record<string, string> = window[CONFIG_KEY] || {};
  return {
    COLLECTIONS_API_PATH: config['COLLECTIONS_API_PATH'] || '/api/collections',
    USERS_API_PATH: config['USERS_API_PATH'] || '/api/users-api',
    ECOSYSTEM_AUTHORIZATION_URL: config['ECOSYSTEM_AUTHORIZATION_URL'] || '/api/persona',
    POS_PIPE_API_PATH: config['POS_PIPE_API_PATH'] || '/explore',
    BASE_URL: config['BASE_URL'] || `${window.location.protocol}//${window.location.host}/collections`,
    EXPORT_BASE_URL: config['EXPORT_BASE_URL'] || `${window.location.protocol}//${window.location.host}/export`,
    INSIGHTS_LOAD_OFFSCREEN: localStorage.getItem('insight_loading_offscreen') === 'true',
    INSIGHTS_LOAD_OFFSCREEN_DISTANCE: parseInt(localStorage.getItem('insight_loading_offscreen_distance')) || 2,
    INSIGHTS_LOAD_DELAY: parseInt(localStorage.getItem('insight_loading_delay')) || 300,
    INSIGHTS_LOAD_CONCURRENCY: parseInt(localStorage.getItem('insight_loading_limit')) || 1,
    COLLECTION_MFE_COOKBOOK_URL:
      'https://ecosystem.pages.td.gfk.com/newron/ui/mfe-cookbook/docs/resources/client-collections/tutorial',
    // COLLECTION_DOWNLOAD_SERVICE_SOCKET_URL: config['COLLECTION_DOWNLOAD_SERVICE_SOCKET_URL'] || 'http://localhost:3082',
    COLLECTION_DOWNLOAD_SERVICE_SOCKET_URL: 'http://localhost:3082',
  };
}

type Config = ReturnType<typeof getConfig>;

export { getConfig, CONFIG_KEY, Config };
